import SubjectList from '../components/SubjectList'

export default function Home() {
  return (
    <>
      <SubjectList />
    </>
  )
}
